import t from "./ghl-ui.es1206.js";
function o(e) {
  return function(r) {
    return t(r, e);
  };
}
export {
  o as default
};
